import * as actions from '../actions/schedule';

const getInitialState = () => ({
  data: null,
  error: null,
  id: null,
  loaded: false,
  loading: false,
  organizationId: null,
  divisionId: null,
  save: {
    data: null,
    error: null,
    id: null,
    organizationId: null,
    divisionId: null,
    loaded: false,
    loading: false,
  },
});

const scheduleReducer = (state = getInitialState(), action) => {
  switch (action.type) {
    case actions.SCHEDULE_SAVE_FETCH: {
      return {
        ...state,
        save: {
          data: null,
          error: null,
          id: action.payload.userId,
          loaded: false,
          loading: true,
          organizationId: action.payload.organizationId,
          divisionId: action.payload.divisionId,
        },
      };


    }
    case actions.SCHEDULE_SAVE_FETCH_ERROR: {
      return {
        ...state,
        save: {
          data: null,
          error: action.payload,
          loaded: true,
          loading: false,
        },
      };
    }
    case actions.SCHEDULE_SAVE_FETCH_SUCCESS: {
      return {
        ...state,
        save: {
          data: action.payload,
          loaded: true,
          loading: false,
        },
      };
    }
    case actions.SCHEDULE_DELETE: {
      return {
        ...state,
        save: {
          data: null,
          id: action.payload.scheduleId,
          loaded: false,
          loading: true,
          organizationId: action.payload.organizationId,
          divisionId: action.payload.divisionId,
        },
      };
    }
    case actions.SCHEDULE_DELETE_ERROR: {
      return {
        ...state,
        save: {
          data: null,
          error: action.payload,
          loaded: true,
          loading: false,
        },
      };
    }
    case actions.SCHEDULE_DELETE_SUCCESS: {
      return {
        ...state,
        save: {
          data: action.payload,
          loaded: true,
          loading: false,
        },
      };
    }
    default:
      return state;
  }
};


export default scheduleReducer;